module.exports = "mutation DeleteSlotItem($slotItemId:ID!){deleteSlotItem(slotItemId:$slotItemId){success}}"